<section class="ticket-metrics rounded-xl !p-5">
  <h2 class="ticket-metrics-title text-xl font-semibold mb-4">
    {{ title | translate }}
  </h2>

  <bo-common-table
    [data]="dataSignal()"
    [columns]="tableColumns"
    [totalRecords]="totalRecords()"
    [sortField]="sortField()"
    [sortOrder]="sortOrder()"
    [mapFieldToSortBy]="mapFieldToSortBy"
    [config]="{
      table: { styleClass: 'p-datatable-striped', tableStyle: { 'min-width': '75rem' }, showBorder: false },
      pagination: { paginator: true },
      toolbar: {
        globalFilterPlaceholder: ('financePages.tmSearchPlaceholder' | translate),
        globalFilterFields: ['event', 'organizerFirstName', 'organizerLastName'],
        filterValues: filterValues
      },
      filters: tableFilters
    }"
    (filterToggle)="toggleFilters()"
    (globalFilterChange)="onGlobalFilterChange($event)"
    (filterChange)="onFilterChange($event)"
    (clearFilters)="onClearFilters()"
    (sortChangeRequested)="onSortChangeRequested($event)"
    (pageChangeRequested)="onPageChangeRequested($event)"
  >
    <ng-template #bodyTemplate let-metric>
      <tr class="ticket-metrics-row cursor-pointer" (click)="onRowClick(metric)">
        <td class="activity-col">
          <div class="flex flex-row items-center gap-3">
            <bo-activity-info-cell
              [sportId]="metric.sportId"
              [event]="metric.event"
              [date]="metric.eventDate"
              [locationName]="metric.locationName"
            ></bo-activity-info-cell>
          </div>
        </td> 
        <td>
          <div class="flex flex-row items-center gap-2">
            <bo-user-info-cell
              [avatarUrl]="metric.organizerAvatarUrl"
              [firstName]="metric.organizerFirstName"
              [lastName]="metric.organizerLastName"
              [subtitle]="metric.organizerRole || null"
              [size]="24"
              [email]="metric.userEmail"
            ></bo-user-info-cell>
          </div>
        </td>
        <td>
          <bo-currency-cell
            [value]="metric.ticketPrice"
            currency="EUR"
            locale="fr-FR"
            [minimumFractionDigits]="2"
            [maximumFractionDigits]="2"
            [showZero]="false"
          ></bo-currency-cell>
        </td>
        <td>
          <bo-currency-cell
            [value]="metric.eventRevenue"
            currency="EUR"
            locale="fr-FR"
            [minimumFractionDigits]="2"
            [maximumFractionDigits]="2"
            [showZero]="false"
            [subText]="ticketsProcessedLabel(metric.ticketsProcessed)"
          ></bo-currency-cell>
        </td>
        <td>
          <bo-currency-cell
            [value]="metric.refunds"
            currency="EUR"
            locale="fr-FR"
            [minimumFractionDigits]="2"
            [maximumFractionDigits]="2"
            [showZero]="false"
            [subText]="ticketRefundLabel(metric.refundCount)"
          ></bo-currency-cell>
        </td>
        <td>
          <bo-currency-cell
            [value]="metric.finalEventRevenue"
            currency="EUR"
            locale="fr-FR"
            [minimumFractionDigits]="2"
            [maximumFractionDigits]="2"
            [showZero]="false"
            [subText]="ticketsSoldLabel(metric.ticketsSold)"
          ></bo-currency-cell>
        </td>
        <td>
          <bo-currency-cell
            [value]="metric.organizerRevenue"
            currency="EUR"
            locale="fr-FR"
            [minimumFractionDigits]="2"
            [maximumFractionDigits]="2"
            [showZero]="false"
            valueColor="#22AE58"
          ></bo-currency-cell>
        </td>
        <td>
          <bo-currency-cell
            [value]="metric.smatchyRevenue"
            currency="EUR"
            locale="fr-FR"
            [minimumFractionDigits]="2"
            [maximumFractionDigits]="2"
            [showZero]="false"
            valueColor="#FCA13B"
          ></bo-currency-cell>
        </td>
        <td>
          <bo-status-cell
            [status]="metric.status"
            [subText]="metric.statusSubText || null"
          ></bo-status-cell>
        </td>
      </tr>
    </ng-template>
  </bo-common-table>

  <bo-activity-detail-drawer
    [activity]="selectedActivity()"
    [visible]="drawerVisible()"
    (visibleChange)="drawerVisible.set($event)"
  />
</section>
